import { fromJS } from 'immutable';
import {
  caseDetail,
  casesList,
  removeIntegration,
  cancelCase,
  deleteCase,
  deleteBusinessProfile,
  snapshot,
  OPEN_CANCEL_CASE_MODAL,
  CLOSE_CANCEL_CASE_MODAL,
  OPEN_DELETE_BUSINESS_PROFILE_MODAL,
  CLOSE_DELETE_BUSINESS_PROFILE_MODAL,
} from './types';
import { combineReducerArray } from '../utils/helpers';

export * from './actions';

const initialState = fromJS({
  detail: {
    data: {},
    network: {
      loading: true,
      error: false,
      success: false,
    },
    cancelCase: {
      modalOpen: false,
      case: false,
    },
    deleteBusinessProfile: {
      modalOpen: false,
      case: false,
    },
    modalError: false,
    submitted: false,
  },
  list: {
    data: [],
    network: {
      loading: true,
      error: false,
      success: false,
    },
  },
});

const getIndexFor = (state, action) => {
  let resultIndex = null;
  state.getIn(['list', 'data']).forEach((detail, index) => {
    if (detail.id === action.caseId) {
      resultIndex = index;
    }
  });
  return resultIndex;
};

const deleteCaseById = (state, action, type) =>
  state.withMutations((currentState) =>
    currentState
      .deleteIn(['list', 'data', getIndexFor(state, action)])
      .setIn(['detail', 'submitted'], type),
  );

const deleteCaseByBusinessId = (state, action, type) =>
  state.withMutations((currentState) => {
    const udateDeletedCases = (list) =>
      list.filter((caseInfo) => caseInfo.businessId !== action.businessId);

    currentState
      .updateIn(['list', 'data'], (list) => udateDeletedCases(list))
      .setIn(['detail', 'submitted'], type);
  });

const updateCaseById = (state, action, type) => {
  const updateCase = (list) => {
    list.push(action.response);
    return list;
  };

  return state.withMutations((currentState) =>
    currentState
      .deleteIn(['list', 'data', getIndexFor(state, action)])
      .updateIn(['list', 'data'], (list) => updateCase(list))
      .setIn(['detail', 'submitted'], type),
  );
};

const casesReducersObject = {
  [caseDetail.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['detail', 'network', 'error'], false)
        .setIn(['detail', 'network', 'loading'], true)
        .setIn(['detail', 'network', 'success'], false)
        .setIn(['detail', 'data'], {})
        .setIn(['detail', 'submitted'], false),
    ),
  [caseDetail.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['detail', 'network', 'error'], false)
        .setIn(['detail', 'network', 'loading'], false)
        .setIn(['detail', 'network', 'success'], true)
        .setIn(['detail', 'data'], action.response)
        .setIn(['detail', 'submitted'], false),
    ),
  [caseDetail.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['detail', 'network', 'error'], true)
        .setIn(['detail', 'network', 'loading'], false)
        .setIn(['detail', 'network', 'success'], false)
        .setIn(['detail', 'data'], {})
        .setIn(['detail', 'submitted'], false),
    ),
  [casesList.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['list', 'network', 'error'], false)
        .setIn(['list', 'network', 'loading'], true)
        .setIn(['list', 'network', 'success'], false)
        .setIn(['list', 'data'], [])
        .setIn(['detail', 'submitted'], false),
    ),
  [casesList.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['list', 'network', 'error'], false)
        .setIn(['list', 'network', 'loading'], false)
        .setIn(['list', 'network', 'success'], true)
        .setIn(['list', 'data'], action.response)
        .setIn(['detail', 'submitted'], false),
    ),
  [casesList.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['list', 'network', 'error'], true)
        .setIn(['list', 'network', 'loading'], false)
        .setIn(['list', 'network', 'success'], false)
        .setIn(['list', 'data'], [])
        .setIn(['detail', 'submitted'], false),
    ),
  [removeIntegration.request]: (state, { id }) =>
    state.withMutations((currentState) =>
      currentState.updateIn(['list', 'data'], (cases) =>
        cases.map((item) =>
          item.businessId !== id
            ? item
            : {
                ...item,
                integration: null,
              },
        ),
      ),
    ),
  [cancelCase.success]: (state, action) => updateCaseById(state, action, 'cancelCase'),
  [cancelCase.failure]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['detail', 'cancelCase', 'modalOpen'], false)
        .setIn(['detail', 'cancelCase', 'case'], false)
        .setIn(['detail', 'modalError'], true)
        .setIn(['detail', 'submitted'], 'cancelCase'),
    ),
  [deleteCase.success]: (state, action) => deleteCaseById(state, action, 'deleteCase'),
  [deleteCase.failure]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['detail', 'cancelCase', 'modalOpen'], false)
        .setIn(['detail', 'cancelCase', 'case'], false)
        .setIn(['detail', 'modalError'], true)
        .setIn(['detail', 'submitted'], 'deleteCase'),
    ),
  [OPEN_CANCEL_CASE_MODAL]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['detail', 'cancelCase', 'modalOpen'], true)
        .setIn(['detail', 'cancelCase', 'case'], action.case)
        .setIn(['detail', 'modalError'], false)
        .setIn(['detail', 'submitted'], false),
    ),
  [CLOSE_CANCEL_CASE_MODAL]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['detail', 'cancelCase', 'modalOpen'], false)
        .setIn(['detail', 'cancelCase', 'case'], false),
    ),
  [deleteBusinessProfile.success]: (state, action) =>
    deleteCaseByBusinessId(state, action, 'deleteCase'),
  [deleteBusinessProfile.failure]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['detail', 'deleteBusinessProfile', 'modalOpen'], false)
        .setIn(['detail', 'deleteBusinessProfile', 'case'], false)
        .setIn(['detail', 'modalError'], true)
        .setIn(['detail', 'submitted'], 'deleteCase'),
    ),
  [OPEN_DELETE_BUSINESS_PROFILE_MODAL]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['detail', 'deleteBusinessProfile', 'modalOpen'], true)
        .setIn(['detail', 'deleteBusinessProfile', 'case'], action.case)
        .setIn(['detail', 'modalError'], false)
        .setIn(['detail', 'submitted'], false),
    ),

  [CLOSE_DELETE_BUSINESS_PROFILE_MODAL]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['detail', 'deleteBusinessProfile', 'modalOpen'], false)
        .setIn(['detail', 'deleteBusinessProfile', 'case'], false),
    ),
  [snapshot.request]: (state, { entityId }) =>
    state.withMutations((currentState) =>
      currentState.updateIn(['list', 'data'], (cases) =>
        cases.map((item) =>
          item.businessId !== entityId
            ? item
            : {
                ...item,
                integration: { loading: true },
              },
        ),
      ),
    ),
  [snapshot.failure]: (state, { entityId }) =>
    state.withMutations((currentState) =>
      currentState.updateIn(['list', 'data'], (cases) =>
        cases.map((item) =>
          item.businessId !== entityId
            ? item
            : {
                ...item,
                integration: { loading: false },
              },
        ),
      ),
    ),
  [snapshot.success]: (state, { entityId, name, generatedAt }) =>
    state.withMutations((currentState) =>
      currentState.updateIn(['list', 'data'], (cases) =>
        cases.map((item) =>
          item.businessId !== entityId
            ? item
            : {
                ...item,
                integration: { name, generatedAt, loading: false },
              },
        ),
      ),
    ),
};

export default combineReducerArray(initialState, [casesReducersObject]);
